/* IMPORT */
import boolean from './boolean.js';
import _switch from './switch.js';
/* MAIN */
const ternary = (when, valueTrue, valueFalse) => {
    const condition = boolean(when);
    return _switch(condition, [[true, valueTrue], [valueFalse]]);
};
/* EXPORT */
export default ternary;
